
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'ColorModuleTitle',
    components: {},
})
export default class ColorModuleTitle extends Vue {
    @Prop({ required: false, default: false }) private activeTab!: string;

    private get colorModuleTitle() {
        if (this.activeTab === 'color-request') {
            return this.$t('Color Request');
        }

        return this.$t('Color Search');
    }
}
